import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GenericService } from '../services/generic.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private genericService: GenericService,private router: Router){ }

  canActivate(route: ActivatedRouteSnapshot): boolean{

    if(this.genericService.isLogin()){
      return true;
    }else{
      this.router.navigate(['/login']);
      return false;
    }
  }
  
}
